import React from "react";
import MenuIcon from "@material-ui/icons/Menu";

function DrawerComponent({ onClick }) {
  return (
    <>
      <button onClick={onClick} className="header__menuButton">
        <MenuIcon />
      </button>
    </>
  );
}

export default DrawerComponent;
